const t = "/metrics/gauge", o = "/reports/logs", r = (s) => async (e) => s.post(t, e), n = (s) => async (e) => s.post(o, e);
export {
  n as sendTelemetryLog,
  r as sendTelemetryMetrics
};
//# sourceMappingURL=index.es489.js.map
